import styled, { css } from 'styled-components';
import { TOUCH_MEDIA } from './PromptComposer.constants';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
`;

export const Pill = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;

  ${({ theme: { colors, spacing, borderRadius } }) => css`
    gap: ${spacing.level3};
    padding: ${spacing.level3};
    border-radius: ${borderRadius.extralarge};
    background-color: ${colors.surfaceContainerHigh};
  `}
`;

const roundButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  ${TOUCH_MEDIA} {
    width: 40px;
    height: 40px;
  }
`;

export const UploadButton = styled.button`
  ${roundButton}
  transition: opacity 0.15s ease;

  ${({ theme: { colors } }) => css`
    background-color: ${colors.primary};
    color: ${colors.onPrimary};

    &:hover:not(:disabled) {
      opacity: 0.88;
    }
  `}
`;

export const SendButton = styled.button`
  ${roundButton}
  transition: background-color 0.15s ease;

  ${({ theme: { colors } }) => css`
    background-color: ${colors.surfaceContainerHigh};
    color: ${colors.onSurfaceVariant};

    &:hover:not(:disabled) {
      background-color: ${colors.surfaceContainerHighest};
    }
  `}
`;

export const InputField = styled.textarea`
  flex: 1;
  min-width: 0;
  min-height: 0;
  max-height: min(200px, 30dvh);
  overflow-y: auto;
  resize: none;
  border: none;
  outline: none;
  background: transparent;
  line-height: 1.5;
  font-family: inherit;

  ${({ theme: { colors, font } }) => css`
    font-size: ${font.bodyMedium.fontSize};
    color: ${colors.onSurface};

    &::placeholder {
      color: ${colors.onSurfaceVariant};
    }

    ${TOUCH_MEDIA} {
      font-size: ${font.bodyLarge.fontSize};
    }
  `}
`;

export const Footer = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  ${({ theme: { spacing } }) => css`
    padding: ${spacing.level3} ${spacing.level4} 0;
  `}
`;
